import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { toggleSupport } from '../../../redux/main/main.actions';

import { selectIsCanvasModalPricingPlanLimitMaxEnabled, selectCanvasModalPricingPlanLimitMaxType } from '../../../redux/diagram/diagram.selectors';
import { disableCanvasPricingPlanLimitMax } from '../../../redux/diagram/diagram.actions';

import { trackEvent } from '../../../lib/analytics';

import Modal from '../Modal/Modal';
import './ModalPricingPlanLimitMaxCanvas.scss';

export const ModalPricingPlanLimitMaxCanvas = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const isOpen = useSelector(selectIsCanvasModalPricingPlanLimitMaxEnabled);
    const modalType = useSelector(selectCanvasModalPricingPlanLimitMaxType);

    const [type, setType] = useState('');

    useEffect(() => {
        if (!modalType) return;
        setType(modalType);
        return () => { };
    }, [modalType]);

    const MODAL_CONTENT = {
        admin_roles: { title: t('m_pricing_limit.admin_roles.title'), description: t('m_pricing_limit.admin_roles.description') },
        workspaces: { title: t('m_pricing_limit.workspaces_canvas.title'), description: t('m_pricing_limit.workspaces_canvas.description') },
        members: { title: t('m_pricing_limit.members.title'), description: t('m_pricing_limit.members.description') },
        diagrams: { title: t('m_pricing_limit.diagrams.title'), description: t('m_pricing_limit.diagrams.description') },
        tables: { title: t('m_pricing_limit.tables.title'), description: t('m_pricing_limit.tables.description') },
        columns: { title: t('m_pricing_limit.columns.title'), description: t('m_pricing_limit.columns.description') },
        notes: { title: t('m_pricing_limit.notes.title'), description: t('m_pricing_limit.notes.description') },
        areas: { title: t('m_pricing_limit.areas.title'), description: t('m_pricing_limit.areas.description') },
        pens: { title: t('m_pricing_limit.pens.title'), description: t('m_pricing_limit.pens.description') },
    };

    const content = MODAL_CONTENT[type];

    const handleSave = () => {
        trackEvent('app_modal_pricing_limit_max_submit', {
            page: 'app',
            type: 'modals',
            subtype: type,
        });
        dispatch(disableCanvasPricingPlanLimitMax(null));
        setTimeout(() => {
            dispatch(toggleSupport('feedback', 'canvas'));
            setType('');
        }, 170);

        setTimeout(() => {
            setType('');
        }, 300);
    };

    const handleCancel = () => {
        dispatch(disableCanvasPricingPlanLimitMax(null));
        setTimeout(() => {
            setType('');
        }, 300);
    };

    return (
        <Modal
            isOpen={isOpen}
            modalClass={`modal-pricing-limit ${type}`}
            onCancel={handleCancel}
        >
            <div className="modal-content-header">{content?.title ?? t('m_pricing_limit.default_title')}</div>

            <div className="modal-content-body">
                <div className='description-text'>
                    {content?.description}
                </div>
                <button onClick={() => handleSave()}>{t('b.upgrade')}</button>
            </div>
        </Modal>
    );
};

export default ModalPricingPlanLimitMaxCanvas;
